import React, { useEffect, useState } from "react";
// import AntivinePic from "../../../../../assets/images/antivine.png";
// import useAppMonitoring from "./useAppMonitoring";
import { useDispatch, useSelector } from "react-redux";
import AppDevicesRow from "./AppDevicesRow";
import moment from "moment";
import useFirebase from "../../../../../useFirebase";
import useDurationOption from "../../../../customHooks/durationOption";
import Select from "react-select";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import { allowBlockApp } from "../../../AxiosRtk/AppActivity";

const DeviceAppsList = ({ deviceSelected, getLangTranslation }) => {
  const dispatch = useDispatch();
  const [allowedApps, setAllowedApps] = useState([]);
  const [allowBlockCategory, setAllowBlockCategory] = useState("ALL");
  const { selectedKidId } = useSelector(({ dashboard }) => dashboard);
  const { appCategoryOptionFunction } = useDurationOption();
  // console.log("allowBlockCategory ==>>", allowBlockCategory)
  const appCategoryOptions = appCategoryOptionFunction();
  // console.log(allowedApps)
  // console.log(moment().format("dddd")?.toLowerCase())
  const currDay = moment().format("dddd")?.toLowerCase();
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [sortedData, setSortedData] = useState([]);

  const { postCollectionData, getCollectionData, createCollectionData } =
    useFirebase();

  // const {
  //     getCollectionData
  // } = useAppMonitoring();

  // useEffect(() => {
  //     if (deviceSelected) {
  //         getCollectionData(11692)
  //     }
  // }, [deviceSelected])

  function callFirebase(payload) {
    if (!setRulesData) {
      createCollectionData(deviceSelected, { timesupervison: payload });
    } else {
      postCollectionData(deviceSelected, { timesupervison: payload });
    }
    getCollectionData(deviceSelected);
  }

  // console.log("setRulesData => ", setRulesData)

  useEffect(() => {
    if (setRulesData) {
      const allowedApps = setRulesData?.timesupervison?.allowedApps ?? [];
      // console.log(allowedApps);
      setAllowedApps(allowedApps);
    }
  }, [setRulesData]);

  function handleDelete(item = null) {
    let tempAllowedApps = [...allowedApps];
    if (!item) {
      tempAllowedApps = tempAllowedApps?.map((app) => {
        const tempObj = { ...app };
        if (tempObj?.isChecked) {
          tempObj["status"] = 4;
          tempObj["deleted"] = 1;
        }
        delete tempObj.isChecked;
        return tempObj;
      });
    } else {
      tempAllowedApps = tempAllowedApps?.map((app) => {
        const tempObj = { ...app };
        if (parseInt(tempObj?.appUuid) === parseInt(item?.appUuid)) {
          tempObj["status"] = 4;
          tempObj["deleted"] = 1;
        }
        delete tempObj.isChecked;
        return tempObj;
      });
    }

    // tempAllowedApps = tempAllowedApps?.map((item) => {
    //     delete item?.isChecked
    // })

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      allowedApps: [...tempAllowedApps],
    };
    callFirebase(collectionPayload);

    // console.log(collectionPayload)
  }

  const getStatus = (status) => {
    switch (status) {
      case "ALLOW":
        return 0;
      case "BLOCK":
        return 1;
      case "WARN":
        return 3;
    }
  };

  function handleStatusChange(item, id, status) {
    let tempAllowedApps = [...allowedApps];

    if (status === "ALERT") {
      tempAllowedApps = tempAllowedApps?.map((app) => {
        const tempObj = { ...app };
        if (tempObj?.appUuid == id) {
          tempObj["enableNotificationWhenUsed"] =
            !tempObj.enableNotificationWhenUsed;
        }

        return tempObj;
      });
    } else {
      const payload = {
        appId: 0,
        appName: item?.appPackageName,
        blockSelected: item?.appUuid,
        case: 8,
        is_load_default_settings: 0,
        kidDeviceId: deviceSelected,
        kidId: selectedKidId,
        packageName: "",
        status: getStatus(status),
      };

      allowBlockApp(payload)
        .then((res) => {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: res?.data?.message,
              message: res?.data?.message,
            })
          );
        })
        .then(() => {
          if (status === "ALLOW") {
            tempAllowedApps = tempAllowedApps?.map((app) => {
              const tempObj = { ...app };
              if (tempObj?.appUuid == id) {
                tempObj["status"] = 0;
              }

              return tempObj;
            });
          } else if (status === "BLOCK") {
            tempAllowedApps = tempAllowedApps?.map((app) => {
              const tempObj = { ...app };
              if (tempObj?.appUuid == id) {
                tempObj["status"] = 1;
              }

              return tempObj;
            });
          } else if (status === "WARN") {
            tempAllowedApps = tempAllowedApps?.map((app) => {
              const tempObj = { ...app };
              if (tempObj?.appUuid == id) {
                tempObj["status"] = 2;
              }

              return tempObj;
            });
          }
          // tempAllowedApps = tempAllowedApps?.map((item) => {
          //     delete item?.isChecked
          // })

          const collectionPayload = {
            ...setRulesData?.timesupervison,
            allowedApps: [...tempAllowedApps],
          };
          callFirebase(collectionPayload);
        })
        .catch((err) => {
          console.log(
            "allow block app catch error  ==>>",
            err?.response?.data?.message
          );
        });
    }

    // console.log(collectionPayload)
  }

  function handleAppSelect(e) {
    const { id, checked } = e.target;
    // console.log(id, checked);

    let tempAllowedApps = [...allowedApps];
    if (id === "SELECT_ALL") {
      tempAllowedApps = tempAllowedApps?.map((app) => {
        const tempObj = { ...app };
        if (!tempObj?.systemApp == 1) {
          tempObj["isChecked"] = checked ? 1 : 0;
        }
        return tempObj;
      });
    } else {
      tempAllowedApps = tempAllowedApps?.map((app) => {
        if (parseInt(app?.appUuid) === parseInt(id)) {
          const tempObj = { ...app };
          tempObj["isChecked"] = checked ? 1 : 0;
          return tempObj;
        }
        return app;
      });
    }
    setAllowedApps(tempAllowedApps);
  }

  useEffect(() => {
    const temp = allowedApps?.map((item) => {
      return { ...item };
    });
    temp?.sort((a, b) => b.status - a.status);
    setSortedData(temp);
  }, [allowedApps]);

  useEffect(() => {
    let tempArr = allowedApps?.map((item) => {
      return { ...item };
    });

    if (allowBlockCategory === "ALLOW") {
      tempArr = tempArr?.filter((item) => item?.status === 0);
    } else if (allowBlockCategory === "BLOCK") {
      tempArr = tempArr?.filter((item) => item?.status === 1);
    } else if (allowBlockCategory === "WARN") {
      tempArr = tempArr?.filter((item) => item?.status === 2);
    }
    setSortedData(tempArr);
  }, [allowBlockCategory]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
        {/*<div className="d-flex align-items-center flex-wrap gap-6">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              name="SELECT_ALL"
              id="SELECT_ALL"
              checked={
                allowedApps?.length > 0 &&
                allowedApps
                  ?.filter((item) => item?.systemApp != 1)
                  ?.filter((item) => item?.isChecked !== 1)?.length < 1
              }
              onChange={(e) => handleAppSelect(e)}
            />
            <label className="form-check-label text-dark" htmlFor="SELECT_ALL">
              {getLangTranslation(
                "MANAGE_NOTIFICATION_SELECT_ALL",
                "Select All"
              )}
            </label>
          </div>
          <button
            className="btn btn-outline-primary"
            type="button"
            onClick={() => handleDelete()}
          >
            {getLangTranslation(
              "DELETE_ALL_SELECTED_APP",
              "Delete All Selected Apps"
            )}
            </button>
        </div>
        <button
          className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-nowrap"
          onClick={() => handleStatusChange("ALLOW")}
        >
          <i className="icon-check-fill success-icon fs-5" />{" "}
          {getLangTranslation("APP_WEB_CATEGORY_STATUS_ALLOWED", "Allow")}
        </button>
        <button
          className="btn btn-outline-warning d-inline-flex align-items-center gap-1 text-nowrap me-3"
          onClick={() => handleStatusChange("WARN")}
        >
          <i className="icon-info-triangle-fill warning-icon fs-5" />{" "}
          {getLangTranslation("APP_WEB_CATEGORY_STATUS_WARNED", "Warn")}
        </button>
        <button
          className="btn btn-outline-danger d-inline-flex align-items-center gap-1 text-nowrap me-3"
          onClick={() => handleStatusChange("BLOCK")}
        >
          <i className="icon-ban danger-icon fs-5" />{" "}
          {getLangTranslation("APP_WEB_CATEGORY_STATUS_BLOCKED", "Blocked")}
          </button>*/}
        <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
          <Select
            className="custom-select col-md-3"
            classNamePrefix="custom-select"
            placeholder="Select category"
            options={appCategoryOptions}
            value={
              appCategoryOptions?.find(
                (item) => item?.value === allowBlockCategory
              ) || ""
            }
            onChange={(val) => {
              setAllowBlockCategory(val.value);
            }}
            isSearchable={false}
          />
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="v-middle" scope="col">
                <div className="form-check">
                  <label className="form-check-label mt-1" htmlFor="taskName">
                    {getLangTranslation("APPLICATION_NAME", "Application name")}
                  </label>
                </div>
              </th>
              <th className="v-middle">
                {getLangTranslation(
                  "APPLICATION_CATEGORY",
                  "Application category"
                )}
              </th>
              <th className="v-middle">
                {getLangTranslation(
                  "CHILD_DASHBOARD_ALLOW_TIME",
                  "Allowed time"
                )}
              </th>
              <th className="v-middle">
                {getLangTranslation("DEVICE_DETAIL_ACTION", "Actions")}
              </th>
              <th className="v-middle"></th>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((item, index) => {
              if (item?.deleted === 0) {
                return (
                  <AppDevicesRow
                    item={item}
                    key={index}
                    currentDay={currDay}
                    handleDelete={handleDelete}
                    handleAppSelect={handleAppSelect}
                    getLangTranslation={getLangTranslation}
                    handleStatusChange={handleStatusChange}
                  />
                );
              }
              return null;
            })}
          </tbody>
        </table>
        {sortedData?.length === 0 && (
          <div className="text-center my-3">
            --- {getLangTranslation("NO_DATA_LOG", "No data found")} ---
          </div>
        )}
      </div>
    </>
  );
};

export default DeviceAppsList;
